import { pluralizeByUnit } from '@sravni/utils/lib/pluralize';
import { Currency } from '../../constants/currency.js';
import { TERMS } from '../../constants/termsAndDuration.js';
import { getAmountString } from '../../helpers/humanization.js';

const getCreditCardsTerms = item => {
    const conditions = [];
    const { maintenancePrice, interestFreePeriodPurchase } = item;
    const cost = maintenancePrice ? `${getAmountString(maintenancePrice, Currency.RUB)} в год` : 'бесплатно';
    conditions.push({ value: cost, description: 'обслуживание', key: 'cost' });
    interestFreePeriodPurchase &&
        conditions.push({
            value: `до ${interestFreePeriodPurchase} ${pluralizeByUnit(interestFreePeriodPurchase, TERMS.day, { possessive: true })}`,
            description: 'льготный период',
            key: 'freePeriod',
        });
    return conditions;
};

export { getCreditCardsTerms };
//# sourceMappingURL=creditCards.js.map
